import {orangeColors} from '../../../../../layouts/theme/designSystem';

export const inviteApplicantModalStyles = (theme: any) => {
  return {
    fieldStyles: {
      marginBottom: '16px',
      '& .MuiOutlinedInput-root': {
        backgroundColor: orangeColors[6],
        color: theme.palette.text.primary,
        '&:hover': {
          backgroundColor: 'white',
        },
        '& fieldset': {
          borderColor: orangeColors[3],
        },
        '&:hover fieldset': {
          borderColor: orangeColors[100],
        },
        '&.Mui-focused fieldset': {
          borderColor: orangeColors[100],
        },
        '& .MuiOutlinedInput-input': {
          caretColor: theme.palette.text.primary,
        },
      },
      '& .MuiInputLabel-root': {
        color: theme.palette.text.primary,
        '&.Mui-focused': {
          color: theme.palette.text.primary,
        },
      },
    },
  };
};
